module.exports = __webpack_public_path__ + "media/images/placeholders/villa-f4f4afa69a9a1f64381c7a3424f21da1.jpg";